<template>
  <v-col class="gray-middle mx-1 pa-2 pa-md-3 rounded">
    <v-row class="px-2 pt-2 pt-md-4">
      <v-col cols="2" class="">
        <v-tooltip
          color="#525867"
          :open-on-click="true"
          :open-on-hover="true"
          bottom
          :max-width="$vuetify.breakpoint.xs ? '90%' : '33%'"
        >
          <template v-slot:activator="{ on, attrs }">
            <img
              v-bind="attrs"
              v-on="on"
              src="/employment_index/Qustion.png"
              width="22px"
              alt="info"
              class="v-align-middle"
            />
          </template>

          <span class="display-18-14 text-left" v-html="info[1]"> </span>
        </v-tooltip>
      </v-col>

      <v-col :class="colorClass" class="px-0 mb-0">
        <p class="pr-3 pr-md-2">
          {{ info[0] }}
        </p>
        <p class="pr-2">
          <span class="display-60-30" v-html="info[2]"></span>
        </p>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  props: {
    info: Array,
    colorClass: String,
  },
}
</script>